<div class="orders-list">
  <div class="d-flex align-items-center justify-content-between pb-3">
    <div class="d-flex justify-content-between">
      <h2 class="mb-0">Line items</h2>
      <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="redirectToLineItem()"
          ><i class="pi pi-plus"></i> Create new line</a
        >
      </div>
    </div>

    <div class="orders-panel col-auto d-flex justify-content-between">
      <!-- <a class="link-gray" (click)="onAddNewLine()"
        ><i class="icon-Add"></i> Add new</a
      > -->
      <div class="ms-2 nav-link p-0 d-flex align-items-center">
        <a class="icon-Notes icon"></a>
      </div>
      <div class="ms-2 nav-link p-0 d-flex align-items-center">
        <a class="icon-Attachment icon"></a>
      </div>
      <div class="ms-2 nav-link p-0 d-flex align-items-center">
        <a class="link pe-1">Use</a> / <a class="link ps-1">Make</a>
      </div>
      <div class="ms-3 nav-link p-0 d-flex align-items-center delete">
        <a class="link" (click)="onDeleteButton()"
          ><i class="pi pi-trash"></i> Delete</a
        >
      </div>
      <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="showModalDialog()"
          ><i class="pi pi-clone"></i> Copy</a
        >
      </div>

      <jni-copy-lines
        #copyline
        [displayModal]="displayModal"
        (closeDialogEvent)="closeModalDialog()"
        [saleOrderId]="OrderLineId"
        (refreshGridEvent)="refreshGrid()"
        [isFromQuotesSummary]="true"></jni-copy-lines>

      <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="exportExcel()"
          ><i class="pi pi-cloud-download"></i> Export excel</a
        >
      </div>
      <!-- <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <a class="link" (click)="confirmAllLines()">Confirm All Lines</a>
      </div> -->
      <!-- <div class="ms-3 nav-link p-0 d-flex align-items-center">
        <i class="icon-Add me-1"></i>
        <a class="link" (click)="redirectToLineItem()">Create new line</a>
      </div> -->
    </div>
  </div>
  <p-table
    #dt
    [rowHover]="true"
    [rows]="25"
    [showCurrentPageReport]="true"
    [scrollable]="true"
    [size]="'small'"
    styleClass="table-listing"
    responsiveLayout="scroll"
    [value]="salesOrderLine"
    [(selection)]="selectedSaleOrderLine"
    selectionMode="multiple"
    [rowHover]="true"
    [rows]="10"
    [showCurrentPageReport]="true"
    [rowsPerPageOptions]="[10, 25, 50]"
    [paginator]="false"
    [filterDelay]="0"
    dataKey="salesOrderLine.lineNumberD365"
    editMode="row">
    <ng-template pTemplate="header">
      <tr class="table-head">
        <th></th>
        <th class="col-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th class="number">#</th>
        <th class="notes">Notes</th>
        <th class="trackable">
          <!-- <input
          class="form-check-input"
          type="checkbox"
          (click)="selectedUnselectAllTrackable($event)"
          id="check"
        /> -->

          <div class="custom-width-switch d-flex gap-2 align-items-center">
            <span>Track</span>
            <div class="form-check form-switch d-flex align-items-center m-0">
              <p-tableHeaderCheckbox
                id="trackable"
                name="trackable"
                (click)="selectedUnselectAllTrackable($event)" />
            </div>
          </div>
        </th>
        <th class="vendor-sku">Vendor Sku</th>
        <th class="vendor-sku">Category</th>
        <th class="description">Description</th>
        <th class="unmatched">UnMat</th>
        <th class="quantity">Qty</th>
        <th class="sell">Sell</th>
        <th class="sell-total">Sell Total</th>
        <th class="net">Net</th>
        <th class="net">Net Total</th>
        <th class="net">Net GP%</th>
        <th class="status">Status</th>
        <th class="vendor-name">Vendor Name</th>
        <!-- <th class="vendor-name">PO Number</th> -->
        <th class="vendor-name">PO Assign</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-salesOrderLine
      let-editing="editing"
      let-ri="rowIndex">
      <ng-container>
        <tr
          class="p-selectable-row"
          [pEditableRow]="salesOrderLine"
          [pSelectableRow]="salesOrderLine"
          (dblclick)="editLine(salesOrderLine.salesOrderLine.id)">
          <td>
            <div class="eddel-btn d-flex align-items-center">
              <button
                *ngIf="!editing"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="pi pi-pencil"
                class="p-button-rounded p-button-text"></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="pi pi-check"
                (click)="onRowEditSave(salesOrderLine.salesOrderLine)"
                class="p-button-rounded p-button-text p-button-success p-mr-2 selectable-color"></button>
              <button
                *ngIf="editing"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="pi pi-times"
                class="p-button-rounded p-button-text p-button-danger"></button>
            </div>
          </td>
          <td class="col-center">
            <p-tableCheckbox
              [pSelectableRow]="salesOrderLine"
              [value]="salesOrderLine"></p-tableCheckbox>
          </td>
          <td
            class="number"
            (click)="
              onRedirectToLinePage(
                salesOrderLine.salesOrderLine.lineNumberD365,
                salesOrderLine.salesOrderLine.id
              )
            ">
            <span class="link line-number">{{
              salesOrderLine.salesOrderLine.lineNumberD365
            }}</span>
          </td>
          <td class="notes">
            <span class="me-1">{{ salesOrderLine.salesOrderLine.notes }}</span>
            <i class="icon-Notes icon"></i>
          </td>
          <td class="attachment">
            <!-- <span class="me-1">{{
              salesOrderLine.salesOrderLine.attachement
            }}</span>
            <i class="icon-Attachment icon"></i> -->

            <div class="custom-width-switch">
              <div class="form-check form-switch d-flex align-items-center m-0">
                <p-toggleswitch
                  id="trackable"
                  name="trackable"
                  [(ngModel)]="salesOrderLine.salesOrderLine.isTrackable"
                  [disabled]="
                    salesOrderLine?.salesOrderLine?.itemNumberD365?.toLowerCase() ===
                      'setup' ||
                    salesOrderLine?.salesOrderLine?.itemNumberD365?.toLowerCase() ===
                      'set up'
                  "
                  (change)="
                    updateOrderLineTrackable(salesOrderLine.salesOrderLine)
                  " />
              </div>
            </div>
          </td>
          <td class="vendor-sku">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="
                    salesOrderLine.salesOrderLine.externalItemNumberD365
                  "
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{ salesOrderLine.salesOrderLine.externalItemNumberD365 }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            <p-cellEditor>
              <ng-template pTemplate="input">
                <p-select
                  class="p-0"
                  id="currency"
                  [(ngModel)]="salesOrderLine.salesOrderLine.itemNumberD365"
                  [options]="releasedProductsList"
                  [optionLabel]="'itemNumberD365'"
                  [optionValue]="'itemNumberD365'"
                  [showClear]="true"
                  [filter]="true">
                </p-select>
              </ng-template>
              <ng-template pTemplate="output">
                {{ salesOrderLine.salesOrderLine.itemNumberD365 }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="description">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="
                    salesOrderLine.salesOrderLine.lineDescriptionD365
                  "
                  required />
              </ng-template>
              <ng-template pTemplate="output" pInputText>
                <span
                  class="max-width-7 text-truncate d-block"
                  pTooltip="{{
                    salesOrderLine.salesOrderLine.lineDescriptionD365
                  }}"
                  tooltipPosition="top"
                  placeholder="Top">
                  {{ salesOrderLine.salesOrderLine.lineDescriptionD365 }}
                </span>
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="unmatched">
            {{
              salesOrderLine.salesOrderLine.deliverRemainderD365 !== null
                ? salesOrderLine.salesOrderLine.deliverRemainderD365
                : salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365
            }}
          </td>
          <td class="quantity">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="
                    salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365
                  "
                  (focusout)="
                    calculateQuantity(
                      salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365,
                      salesOrderLine.salesOrderLine
                    )
                  "
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{ salesOrderLine.salesOrderLine.orderedPurchaseQuantityD365 }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="sell">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [(ngModel)]="salesOrderLine.salesOrderLine.sellD365"
                  (focusout)="
                    calculateSell(
                      salesOrderLine.salesOrderLine.sellD365,
                      salesOrderLine.salesOrderLine
                    )
                  "
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{
                  salesOrderLine.salesOrderLine.sellD365
                    | currency: foreignCurrency : "symbol" : "0.3-3"
                }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td class="sell-total">
            {{
              salesOrderLine.salesOrderLine.sellTotalD365
                | currency: foreignCurrency : "symbol" : "1.2-2"
            }}
          </td>
          <td class="net">
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  jniAutoCompleteBlocker
                  pInputText
                  type="text"
                  [disabled]="!salesOrderLine.salesOrderLine.vendorNameD365"
                  [(ngModel)]="salesOrderLine.salesOrderLine.purchasePriceD365"
                  (focusout)="
                    onNetConversion(
                      salesOrderLine.salesOrderLine.purchasePriceD365,
                      salesOrderLine.salesOrderLine
                    )
                  "
                  required />
              </ng-template>
              <ng-template pTemplate="output">
                {{
                  salesOrderLine.salesOrderLine.purchasePriceD365
                    | currency
                      : salesOrderLine.salesOrderLine.currencyCodeD365
                      : "symbol"
                      : "0.4-4"
                }}
              </ng-template>
            </p-cellEditor>
          </td>
          <td>
            {{
              salesOrderLine?.salesOrderLine?.netTotalD365
                | currency: "USD" : "symbol" : "1.2-2"
            }}
          </td>
          <td>
            {{
              getNetGpPercentage(
                salesOrderLine?.salesOrderLine?.netTotalD365 === null
                  ? salesOrderLine?.salesOrderLine?.netTotalD365
                  : salesOrderLine?.salesOrderLine?.netTotalD36,
                salesOrderLine?.salesOrderLine?.sellTotalD365
              ) | number: "1.2-2"
            }}
            <span
              *ngIf="
                salesOrderLine?.salesOrderLine?.sellTotalD365 &&
                (salesOrderLine?.salesOrderLine?.netTotalD365 ||
                  salesOrderLine?.salesOrderLine?.netTotalD365)
              ">
              {{ percentageSign }}
            </span>
          </td>
          <td class="status">
            {{ salesOrderLine.salesOrderLine.lineStatusD365 }}
          </td>
          <td>
            {{ salesOrderLine.salesOrderLine.vendorNameD365 }}
          </td>
          <!-- <td>
            {{ salesOrderLine.salesOrderLine.purchaseOrderD365 }}
          </td> -->
          <td>
            {{ salesOrderLine.salesOrderLine.vendorPoAssignmentD365 }}
          </td>
        </tr>
      </ng-container>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="20">No line item found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<jni-modal-stacker
  *ngIf="quoteLineDisplayModal"
  [displayModal]="quoteLineDisplayModal"
  (closeEvent)="closeModal()">
  <h1 class="panelHeading">Proposal Line</h1>
  <div class="panelBody">
    <jni-create-line-quote
      [isModal]="true"
      [saleOrderIdFromModal]="OrderLineId"
      [orderLineNumberFromModal]="orderLineNumber"
      [quoteModalStatus]="quoteModalStatus"
      (closeEvent)="closeModal()"
      (scrollHiddenStatus)="addScollHiddenClass()"></jni-create-line-quote>
  </div>
</jni-modal-stacker>

<jni-confirm-dialog
  [dialogMessage]="popUpMessage"
  dialogHeading="Delete Confirmation"
  *ngIf="dialogStatus"
  (confirmDialogStatus)="confirmDialogStatusData($event)">
</jni-confirm-dialog>

<div class="p-d-flex p-flex-column p-ai-center">
  <p-dialog
    [modal]="true"
    [appendTo]="'body'"
    [(visible)]="showWarningTrackleAllDialog">
    <ng-template pTemplate="header">
      <div class="inline-flex items-center justify-center gap-2">
        <span class="font-bold">Warning </span>
        <img
          src="../../../../../assets/images/exclamation-mark.png"
          class="instruction-image"
          alt=""
          width="50px;" />
      </div>
    </ng-template>

    <div class="p-fluid p-dir-col p-p-3">
      <div class="p-field p-mb-2 field-wrap">
        <label class="text-bold matchMode form-group has-float-label mb-1"
          >Are you sure you want to make trackable
          <span>{{ isTrackableAllChecked }}</span> on below line numbers?</label
        >
        <span *ngFor="let obj of salesOrderLineTrackable">
          {{ obj?.salesOrderLine?.lineNumberD365 }},
        </span>
      </div>
      <div
        class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center">
        <button
          class="btn btn-secondary me-2"
          type="button"
          (click)="cancelTrackable()">
          No
        </button>
        <button
          class="btn btn-primary"
          type="submit"
          (click)="saveAllTrackable()">
          Yes
        </button>
      </div>
    </div>
  </p-dialog>
</div>
